import { render, staticRenderFns } from "./AssetInformationClassificationDeleteModal.vue?vue&type=template&id=be43ec0a&"
import script from "./AssetInformationClassificationDeleteModal.vue?vue&type=script&lang=js&"
export * from "./AssetInformationClassificationDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports